<template>
  <aside class="mp-sidebar">
    <div class="mp-sidebar__title"><span class="mp-sidebar__dot"></span>活动分类</div>
    <div
      v-for="cat in visibleCategories"
      :key="cat.id"
      class="mp-sidebar__cat"
      :class="{ 'is-active': activeCategoryId === cat.id }"
      @click="goto('cat', cat.id!)"
    >
      <div class="mp-sidebar__ico" :style="{ background: iconBg(cat), color: iconColor(cat) }">
        <MarketUviewIcon :name="iconOf(cat.icon)" :size="18" :color="iconColor(cat)" />
      </div>
      <div class="mp-sidebar__info">
        <div class="mp-sidebar__name">{{ cat.name }}</div>
        <div class="mp-sidebar__sub">{{ subNames(cat.descNames) }}</div>
      </div>
      <span class="mp-sidebar__arrow">›</span>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { MARKET_CATEGORY_ICONS } from '../../mock/data'
import { useMarketPortal } from '../useMarketPortal'
import { useMarketPortalStore } from '../useMarketPortalStore'
import MarketUviewIcon from './MarketUviewIcon.vue'
import type { MarketPortalCategoryVO } from '@/api/market/portal'

defineOptions({ name: 'MarketPortalSidebar' })

defineProps<{
  activeCategoryId?: number
}>()

const { goto } = useMarketPortal()
const { categories } = useMarketPortalStore()

const visibleCategories = computed(() => categories.value.filter((c) => c.visible !== false))

const iconOf = (key?: string) => (key ? MARKET_CATEGORY_ICONS[key] : undefined) || 'gift-fill'
const subNames = (names?: string[]) => (names && names.length ? names.join(' ') : '暂无模板')
const iconColor = (cat: MarketPortalCategoryVO) => cat.color || '#2b6de8'
const iconBg = (cat: MarketPortalCategoryVO) => `${iconColor(cat)}22`
</script>

<style lang="scss" scoped>
.mp-sidebar {
  width: 200px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  padding: 10px 0 8px;
  position: sticky;
  top: 0;
  max-height: calc(100vh - 120px);
  overflow-y: auto;

  &__title {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #909399;
    font-size: 13px;
    padding: 0 14px 8px;
  }

  &__dot {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    background: #eceefc;
  }

  &__cat {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: #f7f9fd;

      .mp-sidebar__arrow {
        opacity: 1;
      }
    }

    &.is-active {
      background: #f0f5ff;
    }
  }

  &__ico {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__sub {
    font-size: 12px;
    color: #b0b3ba;
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__arrow {
    color: #c9ccd4;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.15s;
  }
}
</style>
